<script lang="ts" setup>
import { DEPOSIT_METHOD_MOBILE_MENUS } from '~/resources/menus'

const { isMaintenance, fetchDepositEWalletsData } = useDepositData()
const { isLogged } = useUser()
const { navigate } = useNavigate()

onMounted(() => {
  nextTick(() => {
    if (isLogged.value) {
      fetchDepositEWalletsData()
    }
  })
})

watch(
  () => isLogged.value,
  (value) => {
    if (value) {
      fetchDepositEWalletsData()
    }
  },
)
</script>
<template>
  <div class="mobile-footer-payments">
    <div class="mobile-footer-payments__title">Phương thức thanh toán</div>
    <div class="mobile-footer-payments__method">
      <div
        v-for="(method, methodIndex) in DEPOSIT_METHOD_MOBILE_MENUS"
        :key="methodIndex"
        :class="[
          'mobile-footer-payments__item',
          { 'is-maintenance': isLogged && isMaintenance(method.method) },
        ]"
        @click="navigate(method.to, true)"
      >
        <img
          class="mobile-footer-payments__image"
          :src="method.image"
          :alt="method.title"
          loading="lazy"
        />
        <div class="mobile-footer-payments__name">
          {{ method.title }}
        </div>
        <div
          v-if="isLogged && isMaintenance(method.method)"
          class="label-maintenance"
        >
          <span>Bảo trì</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/styles/components/mobile/footer/item-payments.scss';
</style>
